import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { LABEL_CONTACT_LINK } from '../authentication/authConstants';
import { CONTACT_DEALER_FLOW, sharedLoginCheck } from '../authentication/sharedLoginCheck';
import MultiRequestModalLoader from './SharedMultiRequestModal/SharedMultiRequestModalLoader';
import contactDealerLauncher from 'dibs-buyer-layout/exports/contactDealerLauncher';

class SharedContactDealerWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = { shouldLoad: false };
        this.showMultiRequestModal =
            props.modalType === 'CONTACT_DEALER' && props.user && !!props.user.isVerifiedTrade;
        this.onModalClose = this.onModalClose.bind(this);
        this.onContactClick = this.onContactClick.bind(this);
        this.launchAuthModal = this.launchAuthModal.bind(this);
    }
    componentDidMount() {
        if (this.props.loadOnMount) {
            this.loadModal();
        }
    }
    componentWillReceiveProps(nextProps) {
        if (!this.props.user && nextProps.user) {
            this.showMultiRequestModal =
                nextProps.modalType === 'CONTACT_DEALER' &&
                nextProps.user &&
                !!nextProps.user.isVerifiedTrade;
        }
    }
    loadModal() {
        if (this.showMultiRequestModal) {
            this.setState({ shouldLoad: true });
        }
    }
    onModalClose() {
        if (this.showMultiRequestModal) {
            this.setState({ shouldLoad: false });
        }
    }
    onContactClick() {
        if (this.showMultiRequestModal) {
            this.loadModal();
        } else {
            const { relay, item, launchOrigin, modalType, user } = this.props;
            contactDealerLauncher({
                environment: relay.environment,
                itemId: item.serviceId,
                launchOrigin,
                modalType,
                userId: (user && user.serviceId) || null,
            });
        }
    }
    launchAuthModal({ email, linkLocation: launchSource }) {
        sharedLoginCheck({
            authOptions: {
                email,
                flow: CONTACT_DEALER_FLOW,
                ga: { label: `${LABEL_CONTACT_LINK} - ${launchSource}` },
            },
        });
    }
    render() {
        const { children, item, message, name, launchOrigin, user, modalContentData } = this.props;

        const { shouldLoad } = this.state;
        return (
            <div onClick={this.onContactClick}>
                {children}
                {this.showMultiRequestModal &&
                    shouldLoad && (
                        <MultiRequestModalLoader
                            load
                            itemId={item.serviceId}
                            launchAuth={this.launchAuthModal}
                            linkLocation={launchOrigin}
                            message={message}
                            name={name}
                            onClose={this.onModalClose}
                            sellerId={item.seller.serviceId}
                            userId={user && user.serviceId}
                            modalContentData={modalContentData}
                        />
                    )}
            </div>
        );
    }
}

SharedContactDealerWrapper.propTypes = {
    children: PropTypes.node,
    item: PropTypes.object.isRequired,
    launchOrigin: PropTypes.string.isRequired,
    loadOnMount: PropTypes.bool,
    message: PropTypes.string,
    modalContentData: PropTypes.object,
    modalType: PropTypes.oneOf(['CONTACT_DEALER', 'REQUEST_PRICE', 'REQUEST_IMAGES']),
    name: PropTypes.string,
    relay: PropTypes.object.isRequired,
    user: PropTypes.object,
};

SharedContactDealerWrapper.defaultProps = {
    loadOnMount: false,
    modalType: 'CONTACT_DEALER',
};

SharedContactDealerWrapper = SharedContactDealerWrapper;

export default createFragmentContainer(SharedContactDealerWrapper, {
    item: graphql`
        fragment SharedContactDealerWrapper_item on Item {
            seller {
                serviceId
            }
            serviceId
        }
    `,
    user: graphql`
        fragment SharedContactDealerWrapper_user on User {
            serviceId
            isVerifiedTrade
        }
    `,
});
